export enum ModelId {
  GPT_5_5 = 'gpt-5.5',
  SOL = 'gpt-5.6-sol',
  LUNA = 'gpt-5.6-luna',
  TERRA = 'gpt-5.6-terra',
  GPT_5_4 = 'gpt-5.4',
  GPT_5_4_MINI = 'gpt-5.4-mini',
  GPT_5_2 = 'gpt-5.2',
}

// Mirrors the backend LiteLLMModel enum in assistant/sdk/types.py. The backend
// serves every OpenAI model via the Responses API; the API choice lives in the
// transport, not in these names (AP-358).
export enum LiteLLMModel {
  GPT_5_5 = 'openai/gpt-5.5',
  SOL = 'openai/gpt-5.6-sol',
  LUNA = 'openai/gpt-5.6-luna',
  TERRA = 'openai/gpt-5.6-terra',
  GPT_5_4 = 'openai/gpt-5.4',
  GPT_5_4_MINI = 'openai/gpt-5.4-mini',
  GPT_5_2 = 'openai/gpt-5.2',
}

export type ReasoningEffort = 'low' | 'medium' | 'high';

export type ModelOption = {
  id: ModelId;
  label: string;
  description: string;
  litellmName: LiteLLMModel;
};

export const DEFAULT_MODEL: ModelOption = {
  id: ModelId.GPT_5_5,
  label: 'GPT-5.5',
  description: 'Default model',
  litellmName: LiteLLMModel.GPT_5_5,
};

export const DEV_MODELS: ModelOption[] = [
  {
    id: ModelId.SOL,
    label: 'Sol',
    description: 'GPT-5.6 preview',
    litellmName: LiteLLMModel.SOL,
  },
  {
    id: ModelId.LUNA,
    label: 'Luna',
    description: 'GPT-5.6 preview',
    litellmName: LiteLLMModel.LUNA,
  },
  {
    id: ModelId.TERRA,
    label: 'Terra',
    description: 'GPT-5.6 preview',
    litellmName: LiteLLMModel.TERRA,
  },
  {
    id: ModelId.GPT_5_4,
    label: 'GPT-5.4',
    description: 'Balanced performance',
    litellmName: LiteLLMModel.GPT_5_4,
  },
  {
    id: ModelId.GPT_5_4_MINI,
    label: 'GPT-5.4 Mini',
    description: 'Faster, lower cost',
    litellmName: LiteLLMModel.GPT_5_4_MINI,
  },
  {
    id: ModelId.GPT_5_2,
    label: 'GPT-5.2',
    description: 'Previous generation',
    litellmName: LiteLLMModel.GPT_5_2,
  },
];

export const ALL_MODELS: ModelOption[] = [DEFAULT_MODEL, ...DEV_MODELS];

export const EFFORT_OPTIONS: ReasoningEffort[] = ['low', 'medium', 'high'];
export const DEFAULT_EFFORT: ReasoningEffort = 'medium';
